import Repository from '@/repositories/marketing'
const resource = '/analytics/custom_reports'

export default {
  fetchAllReports(config) {
    return Repository.get(`${resource}.json`, config)
  },
  fetchNewReport (config){
    return Repository.get(`${resource}/new.json`, config)
  },
  fetchSavedReport(report_id,config) {
    return Repository.get(`${resource}/${report_id}/edit.json`, config)
  },
  fetchDuplicateData(report_id,config) {
    return Repository.get(`${resource}/${report_id}/duplicate.json`, config)
  },
  fetchCampaigns (config){
    return Repository.get(`${resource}/search_campaign.json`, config)
  },
  toggleRecurrence (report_id,config) {
    return Repository.put(`${resource}/${report_id}/toggle_enabled`,config)
  },
  deleteReport(report_id, config) {
    return Repository.delete(`${resource}/${report_id}.json`, config)
  },
  fetchCampaignReport(report_id, config) { //dashboard
    return Repository.get(`${resource}/${report_id}.json`, config)
  },
  updateReport (report_id, data ,config) {
    return Repository.put(`${resource}/${report_id}.json`, data ,config)
  },
  createReport  (data, config) {
    return Repository.post(`${resource}.json`, data ,config)
  },
  fetchLists (config){
    return Repository.get(`${resource}/search_list.json`, config)
  },
  fetchSMSCampaigns (config){
    return Repository.get(`${resource}/search_sms_campaign.json`, config)
  },
  updatedReportInfo(report_id, config) {
    return Repository.get(`${resource}/${report_id}/info.json`, config)
  }
}